import { IColumn } from "cayo.ui";

export const bitLockerColumns: IColumn[] = [];

export const simpleGridColumns: IColumn[] = [];

export const UNIQUE_GRID_OBJECT_PROP = "distinguishedName";
export const PROXY_ADDRESS_DEFAULT_TYPE = "smtp";
